// import React, { useState } from 'react';
// import {  Form } from 'react-bootstrap';
// import MaskedFormControl from 'react-bootstrap-maskedinput'

// import './../CSS/form.css';

// import moment from 'moment'

// import axios from 'axios';
// import Notification from './../../Components/assets/Modals/notification'
// import {REGISTER_NURSE_STUDENT} from './../../url/index'
// import NotifyError from './../../Components/assets/Modals/errorModal'

// const Nursing = () => {
    
//      const handleClear = () => {
//       setEachEntry(initialInputState);
//      }
    
//      const prof_course_List = [
//       {Id:0,Name:'Select'},
//       {Id:10,Name:'GNM Nursing'},
//       {Id:11,Name:'B.Sc Nursing'}
//     ]
     
//      const [validated, setValidated] = useState(false);
//      const initialInputState = { 
//        FirstName: "",
//         MiddleName:"",
//         LastName:"",
//         PersonalEmail:"",
//         PersonalCellNumber:'',
//         ParentCellNumber:'',
//         AdhaarNumber:'',
//         PIN:'',
//         DOB: '',
//         dobError:'',
//         Gender:'',
//         IsAppearedJee:null,
//         Category:'',
//         Type:'',
//         Address:'',
//         FatherName:'',
//          MotherName:'',
//          Religion:'',
//          BloodGroup:'',
//          LastQualifyName:'',
//          LastQualifyBoardName:'',
//          LastQualifyRollNumber:'',
//          LastQualifyMarks:'',
//          ReferredBy:'',
//          SchoolInfo:'',
//          IsSuccess:false,
//          message:'',
//          isLoading:false,
//          title:'',
//          isHideErrorModal:true,
//          errMessage:'',
//          validationError:null,
//          errortitle:'',
//          typeError:'',
//          categoryError:'',
//          courseError:'',
//          MR_Number:'',
//          Amount:'',
        
        
//          CourseId:0,
//          msgList:[],
//          appearedError: ''
      
//       };
//       const [eachEntry, setEachEntry] = useState(initialInputState);
//       const {FirstName, LastName, MiddleName,
//          PersonalEmail, PersonalCellNumber,ParentCellNumber,
//          AdhaarNumber, PIN, DOB, dobError, Gender, Address,
//          FatherName, MotherName,Religion,BloodGroup,
//          LastQualifyName,LastQualifyBoardName, LastQualifyRollNumber, LastQualifyMarks,
//          ReferredBy, SchoolInfo,IsSuccess, message, isLoading, title, isHideErrorModal, msgList,
//           errMessage, validationError, errortitle, typeError, categoryError, IsAppearedJee, courseError,appearedError, MR_Number, Amount, CourseId} = eachEntry;
         
//     const type2 = ''
//           console.log("IsAppearedJee", IsAppearedJee)
//       const handleInputChange = e => {
//           setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
//       };
    
//       const handleNumberChange = e => {
//           let num = e.target.value.replace(/\D/g, "");
//           setEachEntry({ ...eachEntry, [e.target.name]: num });
//       };
     
//     const handleKeyDown = (e) =>{
//       if (e.key === " ") {
//         e.preventDefault();
//       }
//     }
    
    
    
//     const handleDateChange = (e) =>{
//     setEachEntry({ ...eachEntry, [e.target.name]: e.target.value, dobError: "" });
//     }
    
//     const dateValidation = () => {
    
//     const dateArray = DOB.split("/");
    
//     const day = parseInt(dateArray[0]); 
//     const month = parseInt(dateArray[1]); 
//     const year = parseInt(dateArray[2]); 
//     const currentYear = new Date().getFullYear() 
    
    
    
//     if(day > 31)
//     {
//       setEachEntry({ ...eachEntry, dobError: "Enter a valid day" });
//       return false
//     }
//     else if(month > 12)
//     {
//       setEachEntry({ ...eachEntry, dobError: "Enter a valid month" });
//       return false
//     }
//     else if(currentYear < year || (currentYear - year) < 12)
//     {
//       setEachEntry({ ...eachEntry, dobError: "Enter a valid year" });
//       return false
//     }
    
//     else{
//       var mydate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]); 
    
//       setEachEntry({ ...eachEntry, DOB: mydate, dobError: "" });
//       return true;
//     }
    
//     }
    
//     const handleRadioChange = (e) => {
//       setEachEntry({ ...eachEntry, [e.target.name]: e.target.id });
//     }

//     const handleRadioJeeChange = (checked) => {
        
//          setEachEntry({ ...eachEntry, IsAppearedJee: checked, appearedError:''});
//        }
    
//     const handleDDLChange = (e) =>{
//       const {name,value,id} = e.target;
//         setEachEntry({ ...eachEntry, [name]: value, [[id]]:'' });
      
//     }
    
//     const handleCourseDDLChange = (e) => {
//       const {name,value,id} = e.target;
//       setEachEntry({ ...eachEntry, [e.target.name]: value,  [[id]]:'' });
//     }
    
//     const handleMarkChange = (e) => {
//       let num = e.target.value
//       if(num.includes("."))
//       {
//         const dateArray = num.split(".");
//         if(dateArray.length > 0)
//         {
          
//           const temp2 = parseInt(dateArray[1]);
//           if(temp2 < 100) 
//           setEachEntry({ ...eachEntry, [e.target.name]: num });
//         }
       
//       }
//       else{
//         if(num < 100)
//         setEachEntry({ ...eachEntry, [e.target.name]: num });
//       }
     
     
//     }
    
//     const handleSelectValidation = (e) => {
//     const {Type, Category, Course} = eachEntry
    
    
//       if(Category == null || Category.length == 0)
//       {
//         setEachEntry({ ...eachEntry, categoryError: "Select Category" });
//         return  false
//         }
//      if(Type == null || Type.length == 0)
//       {
//       setEachEntry({ ...eachEntry, typeError: "Select Type" });
//       return  false
//       }
    
//       if(CourseId == null || CourseId == 0)
//       {
//         setEachEntry({ ...eachEntry, courseError: "Select Course" });
//       return  false
//       }
    
//      return true;
    
//     }
    
   
//     const  handleAppearError = () => {
//       if(IsAppearedJee == null)
//       {
//         setEachEntry({ ...eachEntry, appearedError: 'Please Select an Option.' });
//         return false;

//       }
//       else return true;
//     }
//      const handleSubmit = async (event) => {
      
//        const form = event.currentTarget;
//        event.preventDefault();
//        event.stopPropagation();
//        handleAppearError()
//        if (form.checkValidity() === true && dateValidation() && handleSelectValidation() && handleAppearError()) {
//         SaveStudent();
//         }
//         else{
//           window.scrollTo(0, 0);
//         }
//          setValidated(true);
        
//      };
    
//      const SaveStudent = async () => {
//       let response = null;
//     var dob = moment.utc(eachEntry.DOB, "DD-MM-YYYY");
    
//       try {
//        // let formData = { ...eachEntry,DOB:dob, PIN: parseInt(eachEntry.PIN), LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), Amount: parseInt(eachEntry.Amount)}
//       let payload = {
//         FirstName: eachEntry.FirstName,
//         MiddleName:eachEntry.MiddleName,
//         LastName:eachEntry.LastName,
//         PersonalEmail:eachEntry.PersonalEmail,
//         PersonalCellNumber:eachEntry.PersonalCellNumber,
//         ParentCellNumber:eachEntry.ParentCellNumber,
//         AdhaarNumber:eachEntry.AdhaarNumber,
//         PIN: parseInt(eachEntry.PIN),
//         DOB: dob,
//         Gender:eachEntry.Gender,
       
//         Category:eachEntry.Category,
//         AccomodationType:eachEntry.Type,
//         Address:eachEntry.Address,
//         FatherName:eachEntry.FatherName,
//          MotherName:eachEntry.MotherName,
//          Religion:eachEntry.Religion,
//          BloodGroup:eachEntry.BloodGroup,
//          LastQualifyName:eachEntry.LastQualifyName,
//          LastQualifyBoardName:eachEntry.LastQualifyBoardName,
//          LastQualifyRollNumber:eachEntry.LastQualifyRollNumber,
//          LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks),
//          ReferredBy:eachEntry.ReferredBy,
//          SchoolInfo:eachEntry.SchoolInfo,
//          MR_Number:eachEntry.MR_Number,
//          Amount: parseInt(eachEntry.Amount),
//          CourseId:  parseInt(eachEntry.CourseId),
//         IsAppearedJee:eachEntry.IsAppearedJee
         
//       }
    
//       console.log("payload", payload)
//      setEachEntry({ ...eachEntry, isLoading: true});
//      response = await axios.post(REGISTER_NURSE_STUDENT, payload);
    
//      if(response.status === 201)
//      {
//       let course_name = ''
      
//        if(payload.CourseId == 10){
//         course_name = "GNM Nursing"
//       }
    
//       else if(payload.CourseId == 11){
//         course_name = "B.Sc Nursing"
//       }
    
//        //let msg = "You have successfully registered for " + course_name + ". Your registration number is " + response.data.Payload + ". Thank you for showing interest for CTG."
//        let temp = []
//        temp.push("You have successfully registered for " + course_name)
//        temp.push("Your registration number is " + response.data.Payload)
//        temp.push("The final admission will take place after submitting the necessary documents and fee at Office")
    
//        setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Success", msgList: temp});
//     }
    
//     else{
//       setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Error occurred!", message:"Error Occurred...!"});
    
//     }
    
//       }
//        catch (error) {
       
//         if(error.response.data)
//         {
//            if(error.response.status === 400)
//          {
//             if(error.response.data.Error.ValidationErrors != null)
//             {
//               const validationError =  error.response.data.Error.ValidationErrors
//               setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: error.response.data.Error.Message, validationError: validationError});
//              // setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true,title:"Error occurred!", message: error.response.data.Error.Message});
//             }
//             else{
//               setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: error.response.data.Error.Message });
//             }
         
//          }
//          else{
//           setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
//          }
//         }
//         else
//         setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
//     }
//     }
//     //"The JSON value could not be converted to System.Nullable`1[System.Int64]. Path: $.AdhaarNumber | LineNumber: 0 | BytePositionInLine: 197."
//     const handleClose = () => {
//       setEachEntry({ ...eachEntry, IsSuccess: false, message : '', msgList : []});
//       window.location.reload();
//       window.scrollTo(0, 0);
      
//     }
//     const handleCloseErrorModal = () => {
//       setEachEntry({ ...eachEntry, isHideErrorModal: true, message : '', msgList : [], errMessage : '',errortitle:'', validationError: null});
//     }
    
//       return (
//         <div className='nurse'>
//         <div className='container'>
      
//           <div className='nurseheading'>
//                    <label>CTG College of Nursing and Medical Science</label>
//                    <br/>
//                    <label>Registration cum Admission Form</label>
//                     </div>
                    
                    
//           <Form className='details' noValidate validated={validated} onSubmit={handleSubmit}>
//            {/* <Container> 
//           <Row className="mb-2"> */}
//       <Form.Group   className="mb-2" controlId="validationCustom01">
//         <Form.Label ><span className="required">First Name</span></Form.Label>
//         <Form.Control 
//         size='sm' 
//         type="input" 
//         placeholder="Enter first name" 
//         required = {true}
//         onChange={handleInputChange}
//         value={FirstName}
//         name="FirstName"
//         onKeyDown={handleKeyDown}
//         />
//         <Form.Control.Feedback type="invalid">
//                   Please enter  first name.
//                 </Form.Control.Feedback>
//       </Form.Group>
    
//       <Form.Group  className="mb-2" controlId="formBasicPassword">
//         <Form.Label>Middle Name</Form.Label>
//         <Form.Control
//          size='sm'
//           type="input"
//            placeholder="Enter middle name"
//            onChange={handleInputChange}
//            value={MiddleName}
//            name="MiddleName"
//            onKeyDown={handleKeyDown}
//            />
//       </Form.Group>
    
//       <Form.Group  className="mb-2" controlId="formBasicPassword">
//         <Form.Label><span className="required">Last Name</span></Form.Label>
//         <Form.Control 
//         size='sm'
//          type="input"
//           placeholder="Enter last name"
//            required
//            onChange={handleInputChange}
//            value={LastName}
//            name="LastName"
//            onKeyDown={handleKeyDown}
//            />
//         <Form.Control.Feedback type="invalid">
//                   Please enter  last name.
//                 </Form.Control.Feedback>
//       </Form.Group>
     
//       <Form.Group   className="mb-2">
//         <Form.Label><span className="required">Contact number</span></Form.Label>
//         <Form.Control 
//         size='sm' 
//         type="tel"
//         maxLength="10"
//         minLength="10"
//          pattern="[0-9]*"
//           required
//           onChange={handleNumberChange}
//           value={PersonalCellNumber}
//           name="PersonalCellNumber"
//           />
//         <Form.Control.Feedback type="invalid">
//                   Please enter  contact number.
//                 </Form.Control.Feedback>
//       </Form.Group>
//       <Form.Group   className="mb-2" controlId="formBasicEmail">
//         <Form.Label>Email</Form.Label>
//         <Form.Control
//          size='sm'
//           type="email"
//            placeholder="Enter email address"
//            onChange={handleInputChange}
//            value={PersonalEmail}
//            name="PersonalEmail"
//            />
//         <Form.Control.Feedback type="invalid">
//         Plesae enter valid email.
//                 </Form.Control.Feedback>
//       </Form.Group>
//       {/* </Row> */}
    
//        {/* <Row className="mb-2"> */}
//       <Form.Group  className="mb-2">
      
//       <Form.Label><span className="required">Date Of Birth</span></Form.Label>
//             <MaskedFormControl size='sm'
//              type='text' 
//               mask='11/11/1111'
//               required
//               onChange={handleDateChange}
//               value = {DOB}
//               name="DOB"
//               />
//             <Form.Control.Feedback type="invalid">
//                   Please enter  DOB.
//                 </Form.Control.Feedback>
//                 <Form.Text style={{color:"red"}}>
//                 {dobError}
//            </Form.Text>
//           </Form.Group>
      
//       <Form.Group className="mb-2">
//       <Form.Label><span className="required">Gender</span></Form.Label>
//       {['radio'].map((type) => (
//         <div key={`inline-${type}`} className="mb-2">
//           <Form.Check
//           size='sm'
//             inline
//             label="Male"
//             name="Gender"
//             type={type}
//             value = {Gender}
//             onChange = {handleRadioChange}
//             id= 'Male'
//             required
//           />
//           <Form.Check
//           size='sm'
//             inline
//             label="Female"
//             name="Gender"
//             type={type}
//             value = {Gender}
//             onChange = {handleRadioChange}
//             id= 'Female'
//             required
//           />
//            <Form.Check
//             size='sm'
//             inline
//             label="Other"
//             type={type}
//              name="Gender"
//              value = {Gender}
//              onChange = {handleRadioChange}
//              id= 'Other'
//              required
//           /> 
          
//         </div>
        
//       ))}
//        <Form.Control.Feedback type="invalid">
//          Please select  gender.
//        </Form.Control.Feedback>
//       </Form.Group>
     
      
//         <Form.Group  className="mb-2">
      
//       <Form.Label><span className="required">Select Course</span></Form.Label>
//       <Form.Select size='sm' aria-label="Default select example" 
//        name="CourseId"
//        id = 'courseError'
//        defaultValue={'DEFAULT'}
//        onChange = {handleCourseDDLChange}
//        value = {CourseId}
//       required
//       >
    
//     {prof_course_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
    
//     </Form.Select>
//     <Form.Control.Feedback type="invalid">
//                   Please select  Course.
//                 </Form.Control.Feedback>
//                 <Form.Text style={{color:"red"}}>
//                 {courseError}
//            </Form.Text>
//     </Form.Group>
      
     
   

//       <Form.Group className="mb-2">
//   <Form.Label>
//     <span className="required">Have you appeared OJEE ?</span>
//   </Form.Label>
//   <div className="mb-2">
//     <Form.Check
//       size="sm"
//       inline
//       label="Yes"
//       name="isAppearedJee"
//       type="radio"
//       value="true"
//       checked={IsAppearedJee === true}
//       onChange={() => handleRadioJeeChange(true)}
//       id="ojje-yes"
//      // isInvalid={form.checkValidity() && IsAppearedJee === null }
//     />
//     <Form.Check
//       size="sm"
//       inline
//       label="No"
//       name="isAppearedJee"
//       type="radio"
//       value="false"
//       checked={IsAppearedJee === false}
//       onChange={() => handleRadioJeeChange(false)}
//       id="ojje-no"
//      // isInvalid={ IsAppearedJee === null}
//     />
//   </div>
   
//     <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
//       {appearedError}
//     </Form.Control.Feedback>
  
// </Form.Group>

   
    
//     <Form.Group  className="mb-2">
//     <Form.Label><span className="required">Select Category</span></Form.Label>
//     <Form.Select required size='sm' aria-label="Default select example"
//      name="Category"
//      id = 'categoryError'
//      defaultValue={'DEFAULT'}
//      onChange = {handleDDLChange}
     
//     >
//     <option value="DEFAULT" disabled>Select</option>
//       <option value={"ST"}>ST</option>
//       <option value={"SC"}>SC</option>
//       <option value={"OBC"}>OBC</option>
//       <option value={"SEBC"}>SEBC</option>
//       <option value={"General"}>General</option>
//     </Form.Select>
//     <Form.Control.Feedback type="invalid">
//          Please select  category.
//        </Form.Control.Feedback>
//        <Form.Text style={{color:"red"}}>
//                 {categoryError}
//            </Form.Text>
//     </Form.Group>
    
//     <Form.Group required  className="mb-2">
      
//       <Form.Label><span className="required">Select Type</span></Form.Label>
//       <Form.Select required size='sm' aria-label="Default select example" 
//        name="Type"
//        id = 'typeError'
//        defaultValue={'DEFAULT'}
//        onChange = {handleDDLChange}
//       >
//       <option value="DEFAULT" disabled>Select</option>
//        {/* <option value="" disabled selected>Select</option>  */}
//       <option value= {"Day Boarding"}>Day Boarding</option>
//       <option value= {"Day Scholar"}>Day Scholar</option>
//       <option value={"Residential"}>Residential</option>
//     </Form.Select>
//     <Form.Control.Feedback type="invalid">
//                   Please select  Type.
//                 </Form.Control.Feedback>
//                  <Form.Text style={{color:"red"}}>
//                 {typeError}
//            </Form.Text>
//     </Form.Group>
    
//     <Form.Group className="mb-2" controlId="formBasicPassword">
//         <Form.Label>MR Number</Form.Label>
//         <Form.Control size='sm'
//          type="input" 
//          placeholder="Enter money receipt no."
         
//           value={MR_Number}
//           name = "MR_Number"
//           onChange={handleInputChange}
//           />
        
//       </Form.Group>
    
//       <Form.Group  xs={2} className="mb-2" >
//       <Form.Label>Amount Paid</Form.Label>
//         <Form.Control  size='sm' 
//        type="tel"
//        maxLength="5"
//        minLength="3"
//         pattern="[0-9]*"
//          onChange={handleNumberChange}
//          value={Amount}
//          name="Amount"
//           />
        
//       </Form.Group>
      
//       {/* </Row>
//       <Row className="mb-2"> */}
//     <Form.Group className="mb-2" controlId="formBasicPassword" required>
//         <Form.Label><span className="required">Father's Name</span></Form.Label>
//         <Form.Control size='sm'
//          type="input" 
//          placeholder="Enter father name"
//           required
//           value={FatherName}
//           name = "FatherName"
//           onChange={handleInputChange}
//           />
//         <Form.Control.Feedback type="invalid">
//          Please enter  father's name.
//        </Form.Control.Feedback>
//       </Form.Group>
    
//       <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//         <Form.Label><span className="required">Mother's Name</span></Form.Label>
//         <Form.Control size='sm'
//          type="input" 
//          placeholder="Enter mother name" 
         
//          value={MotherName}
//          name = "MotherName"
//          onChange={handleInputChange}
//          required/>
//         <Form.Control.Feedback type="invalid">
//          Please mother's  name.
//        </Form.Control.Feedback>
//       </Form.Group>
//       <Form.Group  className="mb-2" required>
//         <Form.Label><span className="required">Parent's Contact Number</span></Form.Label>
//         <Form.Control size='sm'
//           type="tel"
//           maxLength="10"
//           minLength="10"
//            pattern="[0-9]*"
//             required
//             onChange={handleNumberChange}
//             value={ParentCellNumber}
//             name="ParentCellNumber"
//          />
//         <Form.Control.Feedback type="invalid">
//          Please enter Parent's Contct no.
//        </Form.Control.Feedback>
//       </Form.Group>
//       <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//       <Form.Label><span className="required">Religion</span></Form.Label>
//         <Form.Control size='sm' 
//         type="input"
//          placeholder="Enter religion"
//          value={Religion}
//          name = "Religion"
//          onChange={handleInputChange}
//          required/>
//         <Form.Control.Feedback type="invalid">
//          Please enter religion.
//        </Form.Control.Feedback>
//       </Form.Group>
    
//       <Form.Group  className="mb-2" >
//         <Form.Label>Blood Group</Form.Label>
//         <Form.Control size='sm' 
//         type="input" 
//         placeholder="Enter blood group" 
//         value={BloodGroup}
//          name = "BloodGroup"
//          onChange={handleInputChange}
//         />
//       </Form.Group>
//       {/* </Row>
//       <Row className="mb-2"> */}
//      <Form.Group   className="mb-2" controlId="formBasicPassword" required>
//         <Form.Label><span className="required">Adhaar Number</span></Form.Label>
//         <Form.Control size='sm' 
//         type="tel"
//         maxLength="12"
//         minLength="12"
//          pattern="[0-9]*"
//           required
//           onChange={handleNumberChange}
//           value={AdhaarNumber}
//           name="AdhaarNumber"
//         />
//         <Form.Control.Feedback type="invalid">
//          Please enter adhhar no.
//        </Form.Control.Feedback>
      
//       </Form.Group>
    
      
    
//       <Form.Group  className="mb-2" required>
//         <Form.Label><span className="required">Last Qualification</span></Form.Label>
//         <Form.Control size='sm'
//          type="input"
//           placeholder="Enter last qualification"
//           value={LastQualifyName}
//           name = "LastQualifyName"
//           onChange={handleInputChange}
//           required/>
//         <Form.Control.Feedback type="invalid">
//          Please enter Last Qualification.
//        </Form.Control.Feedback>
//       </Form.Group>
     
//       <Form.Group  style = {{width:"280px"}} xs={3} className="mb-2" controlId="formBasicPassword" required>
//         <Form.Label><span className="required">Last Qualification Board</span></Form.Label>
//         <Form.Control   size='sm' 
//         type="input"
//          placeholder="Enter last qualification board" 
//          value={LastQualifyBoardName}
//           name = "LastQualifyBoardName"
//           onChange={handleInputChange}
//          required/>
//         <Form.Control.Feedback type="invalid" >
//          Please enter last qualification.
//        </Form.Control.Feedback>
//       </Form.Group>
     
//       <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//         <Form.Label><span className="required">Roll number</span></Form.Label>
//         <Form.Control size='sm'
//          type="input" 
//          placeholder="Enter roll number" 
//          value={LastQualifyRollNumber}
//          name = "LastQualifyRollNumber"
//          onChange={handleInputChange}
//          required/>
//         <Form.Control.Feedback type="invalid">
//          Please enter roll number.
//        </Form.Control.Feedback>
//       </Form.Group>
    
//       <Form.Group  className="mb-2">
//         <Form.Label>% of Marks</Form.Label>
//         <Form.Control size='sm' 
//         type="number" 
//          className="w-50" 
//          max={100}
//          maxLength = {5}
//          value={LastQualifyMarks}
//          name = "LastQualifyMarks"
//          onChange={handleMarkChange}
//          />
//       </Form.Group>
//       <Form.Group  xs={2} className="mb-2" >
      
//       <Form.Label><span className="required">PIN Code</span></Form.Label>
//         <Form.Control  size='sm' className="w-50" 
//        type="tel"
//        maxLength="6"
//        minLength="6"
//         pattern="[0-9]*"
//          required
//          onChange={handleNumberChange}
//          value={PIN}
//          name="PIN"
//           />
//         <Form.Control.Feedback type="invalid">
//          Please enter  PIN.
//        </Form.Control.Feedback>
//       </Form.Group>
//       {/* </Row> */}
      
//       <Form.Group  xs={3} className="mb-2" controlId="formControlsTextarea">
//         <Form.Label><span className="required">Address</span></Form.Label>
//         <textarea size='sm' className="form-control rounded-0"
//          required id="exampleFormControlTextarea2" 
//          rows="3" cols = '40'
//          placeholder="Enter full address"
//          value={Address}
//          name = "Address"
//          onChange={handleInputChange}
//          ></textarea>
//         <Form.Control.Feedback type="invalid">
//          Please enter  address.
//        </Form.Control.Feedback>
//       </Form.Group>
//       {/* <Row className="mb-2"> */}
//       <Form.Group  className="mb-2" controlId="formControlsTextarea">
//         <Form.Label>Referred by</Form.Label>
//         <textarea size='sm' className="form-control rounded-0"
//          id="exampleFormControlTextarea2" 
//          rows="3" cols = '40' 
//          placeholder="Referred by whom, address and contact number"
//          value={ReferredBy}
//          name = "ReferredBy"
//          onChange={handleInputChange}
//          ></textarea>
//       </Form.Group>
//       <Form.Group  className="mb-2" controlId="formControlsTextarea">
//         <Form.Label>{"Last College Details"}</Form.Label>
//         <textarea size='sm'
//          className="form-control rounded-0" 
//          id="exampleFormControlTextarea2" 
//          rows="3" cols = '40' 
//          placeholder= "Enter college details with address"
//          value={SchoolInfo}
//          name = "SchoolInfo"
//          onChange={handleInputChange}
//          ></textarea>
//       </Form.Group>
     
     
//       <div className="form-row" style={{width:'30%'}}>
//       <div className="d-grid gap-2">
//         <p></p>
        
      
//       <button className="btn btn-primary" style={{background:'#055374'}} type="submit">
//       <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
//         Register
//         </button>
      
//       <button className="btn btn-primary"style={{background:'red'}}  type="button" onClick={handleClear}>Clear</button>
//     </div>
//       {/* <div class="col">
//       <Form.Group  className='Reg' controlId="formControlsTextarea">
//       <Button variant='success' class="btn btn-primary"  type="submit">
//       <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
//        Register
        
//       </Button>
//       </Form.Group>
//       </div>
    
//       <div class="col">
//       <Form.Group className='Reg' controlId="formControlsTextarea">
      
//       <Button   variant='danger' type="submit" onClick={navigateToHome}>
//         Cancel
//       </Button>
//       </Form.Group>
//       </div> */}
      
//       </div>
    
      
    
     
//       {/* </Container>  */}
//     </Form>
    
    
//     <Notification
//     IsSuccess = {IsSuccess}
//     handleClose = {handleClose}
//     Message = {message}
//     msgList = {msgList}
//     title = {title}
    
//     />
    
//     {!isHideErrorModal && <NotifyError
//     isHide = {isHideErrorModal}
//      handleCloseErrorModal ={handleCloseErrorModal}
//       title = {errortitle}
//        message = {errMessage}
//         Errors ={validationError}
//     />} 
//         </div>
//         </div>
//       )
// }

// export default Nursing



// NEW DESIGN FORM 

import React, { useState } from "react";
import axios from 'axios';
import {REGISTER_NURSE_STUDENT} from './../../url/index' 


const COLORS = {
  primary: "#0a4f6e",
  primaryLight: "#1a7fa0",
  accent: "#00c2a8",
  danger: "#e05252",
  bg: "#f0f5f8",
  card: "#ffffff",
  border: "#d0dde6",
  label: "#4a6070",
  text: "#1a2e3b",
  muted: "#8fa8b8",
};

const styles = {
  page: {
    minHeight: "100vh",
    background: `linear-gradient(135deg, #0a4f6e 0%, #0d7a99 50%, #00c2a8 100%)`,
    padding: "24px 16px 48px",
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
    color: "#fff",
  },
  headerBadge: {
    display: "inline-block",
    background: "rgba(255,255,255,0.15)",
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: "20px",
    padding: "4px 16px",
    fontSize: "12px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "#a8eee8",
    marginBottom: "12px",
  },
  headerTitle: {
    fontSize: "clamp(20px, 4vw, 28px)",
    fontWeight: "700",
    margin: "0 0 6px",
    letterSpacing: "-0.3px",
  },
  headerSub: {
    fontSize: "14px",
    opacity: 0.8,
    margin: 0,
  },
  formCard: {
    maxWidth: "720px",
    margin: "0 auto",
    background: COLORS.card,
    borderRadius: "20px",
    boxShadow: "0 24px 64px rgba(10,79,110,0.22)",
    overflow: "hidden",
  },
  section: {
    padding: "24px 28px",
    borderBottom: `1px solid ${COLORS.border}`,
  },
  sectionLast: {
    padding: "24px 28px",
  },
  sectionTitle: {
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: COLORS.accent,
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sectionTitleLine: {
    flex: 1,
    height: "1px",
    background: `linear-gradient(90deg, ${COLORS.accent}44, transparent)`,
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: COLORS.label,
    letterSpacing: "0.3px",
  },
  required: {
    color: COLORS.accent,
    marginLeft: "2px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    border: `1.5px solid ${COLORS.border}`,
    borderRadius: "10px",
    fontSize: "14px",
    color: COLORS.text,
    background: "#f8fbfd",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s, background 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  inputFocus: {
    borderColor: COLORS.primaryLight,
    background: "#fff",
    boxShadow: `0 0 0 3px rgba(26,127,160,0.12)`,
  },
  inputError: {
    borderColor: COLORS.danger,
    background: "#fff8f8",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    border: `1.5px solid ${COLORS.border}`,
    borderRadius: "10px",
    fontSize: "14px",
    color: COLORS.text,
    background: "#f8fbfd",
    outline: "none",
    cursor: "pointer",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238fa8b8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    paddingRight: "32px",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  textarea: {
    width: "100%",
    padding: "10px 14px",
    border: `1.5px solid ${COLORS.border}`,
    borderRadius: "10px",
    fontSize: "14px",
    color: COLORS.text,
    background: "#f8fbfd",
    outline: "none",
    resize: "vertical",
    minHeight: "80px",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  errorText: {
    fontSize: "11px",
    color: COLORS.danger,
    marginTop: "2px",
  },
  radioGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
    padding: "8px 16px",
    border: `1.5px solid ${COLORS.border}`,
    borderRadius: "8px",
    fontSize: "13px",
    color: COLORS.label,
    transition: "all 0.2s",
    background: "#f8fbfd",
    userSelect: "none",
  },
  radioLabelActive: {
    borderColor: COLORS.primaryLight,
    background: "rgba(26,127,160,0.08)",
    color: COLORS.primary,
    fontWeight: "600",
  },
  radioInput: {
    accentColor: COLORS.primaryLight,
    width: "14px",
    height: "14px",
    cursor: "pointer",
  },
  footer: {
    padding: "20px 28px",
    background: "#f8fbfd",
    borderTop: `1px solid ${COLORS.border}`,
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
  },
  btnPrimary: {
    flex: 1,
    minWidth: "140px",
    padding: "13px 24px",
    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryLight})`,
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    letterSpacing: "0.3px",
    transition: "opacity 0.2s, transform 0.1s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontFamily: "inherit",
  },
  btnSecondary: {
    padding: "13px 24px",
    background: "transparent",
    color: COLORS.danger,
    border: `1.5px solid ${COLORS.danger}`,
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
    fontFamily: "inherit",
  },
  spinner: {
    width: "16px",
    height: "16px",
    border: "2px solid rgba(255,255,255,0.3)",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    display: "inline-block",
  },
  modal: {
    position: "fixed",
    inset: 0,
    background: "rgba(10,30,50,0.55)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  },
  modalCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "32px",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
  },
  modalIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 16px",
    fontSize: "24px",
  },
};

// ─── Reusable Field Components ───────────────────────────────────────────────

const Field = ({ label, required: req, error, children }) => (
  <div style={styles.fieldGroup}>
    <label style={styles.label}>
      {label}
      {req && <span style={styles.required}>*</span>}
    </label>
    {children}
    {error && <span style={styles.errorText}>{error}</span>}
  </div>
);

const Input = React.forwardRef(({ error, ...props }, ref) => {
  const [focused, setFocused] = useState(false);
  return (
    <input
      ref={ref}
      style={{
        ...styles.input,
        ...(focused ? styles.inputFocus : {}),
        ...(error ? styles.inputError : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      {...props}
    />
  );
});

const Select = ({ children, error, ...props }) => {
  const [focused, setFocused] = useState(false);
  return (
    <select
      style={{
        ...styles.select,
        ...(focused ? styles.inputFocus : {}),
        ...(error ? styles.inputError : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      {...props}
    >
      {children}
    </select>
  );
};

const Textarea = ({ error, ...props }) => {
  const [focused, setFocused] = useState(false);
  return (
    <textarea
      style={{
        ...styles.textarea,
        ...(focused ? styles.inputFocus : {}),
        ...(error ? styles.inputError : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      {...props}
    />
  );
};

const RadioGroup = ({ options, name, value, onChange }) => (
  <div style={styles.radioGroup}>
    {options.map((opt) => (
      <label
        key={opt.value}
        style={{
          ...styles.radioLabel,
          ...(value === opt.value ? styles.radioLabelActive : {}),
        }}
      >
        <input
          type="radio"
          name={name}
          value={opt.value}
          checked={value === opt.value}
          onChange={() => onChange(opt.value)}
          style={styles.radioInput}
        />
        {opt.label}
      </label>
    ))}
  </div>
);

const SectionTitle = ({ children }) => (
  <div style={styles.sectionTitle}>
    {children}
    <div style={styles.sectionTitleLine} />
  </div>
);

// ─── Success / Error Modals ───────────────────────────────────────────────────

const SuccessModal = ({ msgList, onClose }) => (
  <div style={styles.modal}>
    <div style={styles.modalCard}>
      <div
        style={{
          ...styles.modalIcon,
          background: "rgba(0,194,168,0.12)",
          color: COLORS.accent,
        }}
      >
        ✓
      </div>
      <h3 style={{ color: COLORS.primary, marginBottom: "12px", fontSize: "18px" }}>
        Registration Successful!
      </h3>
      {msgList.map((m, i) => (
        <p key={i} style={{ color: COLORS.label, fontSize: "14px", margin: "6px 0" }}>
          {m}
        </p>
      ))}
      <button
        onClick={onClose}
        style={{
          ...styles.btnPrimary,
          marginTop: "20px",
          width: "100%",
          flex: "unset",
        }}
      >
        Done
      </button>
    </div>
  </div>
);

const ErrorModal = ({ title, message, errors, onClose }) => (
  <div style={styles.modal}>
    <div style={styles.modalCard}>
      <div
        style={{
          ...styles.modalIcon,
          background: "rgba(224,82,82,0.1)",
          color: COLORS.danger,
        }}
      >
        !
      </div>
      <h3 style={{ color: COLORS.danger, marginBottom: "8px", fontSize: "18px" }}>
        {title}
      </h3>
      <p style={{ color: COLORS.label, fontSize: "14px", marginBottom: "12px" }}>
        {message}
      </p>
      {errors && errors.length > 0 && (
  <ul style={{ textAlign: "left", paddingLeft: "20px", fontSize: "13px", color: COLORS.label }}>
    {errors.map((e, i) => (
      <li key={i}>
        <strong>{e.Name}:</strong> {e.Reason}
      </li>
    ))}
  </ul>
)}
      <button
        onClick={onClose}
        style={{
          ...styles.btnSecondary,
          marginTop: "16px",
          width: "100%",
        }}
      >
        Close
      </button>
    </div>
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const Nursing = () => {
  const initial = {
    FirstName: "", MiddleName: "", LastName: "",
    PersonalEmail: "", PersonalCellNumber: "", ParentCellNumber: "",
    AdhaarNumber: "", PIN: "", DOB: "", Gender: "",
    IsAppearedJee: null, Category: "", Type: "",
    Address: "", FatherName: "", MotherName: "",
    Religion: "", BloodGroup: "",
    LastQualifyName: "", LastQualifyBoardName: "",
    LastQualifyRollNumber: "", LastQualifyMarks: "",
    ReferredBy: "", SchoolInfo: "",
    MR_Number: "", Amount: "", CourseId: "0",
    // UI state
    isLoading: false, IsSuccess: false, msgList: [],
    showError: false, errortitle: "", errMessage: "", validationError: null,
    // Errors
    dobError: "", appearedError: "", courseError: "",
    categoryError: "", typeError: "",
  };

  const [form, setForm] = useState(initial);
  const [submitted, setSubmitted] = useState(false);

  const set = (updates) => setForm((f) => ({ ...f, ...updates }));

  const handleChange = (e) =>
    set({ [e.target.name]: e.target.value });

  const handleNumberChange = (e) =>
    set({ [e.target.name]: e.target.value.replace(/\D/g, "") });

  const handleKeyDown = (e) => {
    if (e.key === " ") e.preventDefault();
  };

  const handleDOBChange = (e) => {
    let v = e.target.value.replace(/\D/g, "");
    if (v.length > 2) v = v.slice(0, 2) + "/" + v.slice(2);
    if (v.length > 5) v = v.slice(0, 5) + "/" + v.slice(5);
    v = v.slice(0, 10);
    set({ DOB: v, dobError: "" });
  };

  const validateDOB = () => {
    const parts = form.DOB.split("/");
    if (parts.length !== 3) { set({ dobError: "Enter date as DD/MM/YYYY" }); return false; }
    const [day, month, year] = parts.map(Number);
    const currentYear = new Date().getFullYear();
    if (day < 1 || day > 31) { set({ dobError: "Enter a valid day" }); return false; }
    if (month < 1 || month > 12) { set({ dobError: "Enter a valid month" }); return false; }
    if (year > currentYear || currentYear - year < 12) { set({ dobError: "Enter a valid year" }); return false; }
    return true;
  };

  const validateSelects = () => {
    if (!form.Category) { set({ categoryError: "Select Category" }); return false; }
    if (!form.Type) { set({ typeError: "Select Type" }); return false; }
    if (!form.CourseId || form.CourseId === "0") { set({ courseError: "Select Course" }); return false; }
    return true;
  };

  const validateAppeared = () => {
    if (form.IsAppearedJee === null) {
      set({ appearedError: "Please select an option." });
      return false;
    }
    return true;
  };

  const isRequired = (v) => submitted && (!v || v.trim() === "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const dobOk = validateDOB();
    const selectsOk = validateSelects();
    const appearedOk = form.CourseId === "11" ? validateAppeared() : true;

    const requiredFields = [
      "FirstName", "LastName", "PersonalCellNumber", "Gender",
      "FatherName", "MotherName", "ParentCellNumber", "Religion",
      "AdhaarNumber", "LastQualifyName", "LastQualifyBoardName",
      "LastQualifyRollNumber", "PIN", "Address", "DOB"
    ];
    const allFilled = requiredFields.every((f) => form[f] && form[f].trim() !== "");

    if (!allFilled || !dobOk || !selectsOk || !appearedOk) {
      window.scrollTo(0, 0);
      return;
    }

    set({ isLoading: true });
    try {
      const dob = new Date(
        `${form.DOB.split("/")[2]}-${form.DOB.split("/")[1]}-${form.DOB.split("/")[0]}`
      );
      const payload = {
        FirstName: form.FirstName, MiddleName: form.MiddleName, LastName: form.LastName,
        PersonalEmail: form.PersonalEmail, PersonalCellNumber: form.PersonalCellNumber,
        ParentCellNumber: form.ParentCellNumber, AdhaarNumber: form.AdhaarNumber,
        PIN: parseInt(form.PIN), DOB: dob.toISOString(), Gender: form.Gender,
        Category: form.Category, AccomodationType: form.Type, Address: form.Address,
        FatherName: form.FatherName, MotherName: form.MotherName, Religion: form.Religion,
        BloodGroup: form.BloodGroup, LastQualifyName: form.LastQualifyName,
        LastQualifyBoardName: form.LastQualifyBoardName,
        LastQualifyRollNumber: form.LastQualifyRollNumber,
        LastQualifyMarks: parseFloat(form.LastQualifyMarks) || null,
        ReferredBy: form.ReferredBy, SchoolInfo: form.SchoolInfo,
        MR_Number: form.MR_Number, Amount: parseInt(form.Amount) || null,
        CourseId: parseInt(form.CourseId), IsAppearedJee: form.IsAppearedJee,
      };

      // Replace with your actual API endpoint
       const response = await axios.post(REGISTER_NURSE_STUDENT, payload);
      // Simulated success for demo:
      if(response.status === 201)
      {
        console.log("Payload:", payload);
        const courseMap = { 10: "GNM Nursing", 11: "B.Sc Nursing" };
        const courseName = courseMap[payload.CourseId] || "the selected course";
        set({
          isLoading: false, IsSuccess: true,
          msgList: [
            `You have successfully registered for ${courseName}`,
            "Your registration number will be sent to you shortly",
            "Final admission takes place after document submission and fee payment at Office",
          ],
        });
      }
      
    } catch (error) {
      debugger;
      const errData = error?.response?.data?.Error;
      set({
        isLoading: false, showError: true,
        errortitle: "Error Occurred",
        errMessage: errData?.Message || "Please contact support.",
        validationError: errData?.ValidationErrors || null,
      });
    }
  };

  const handleClear = () => {
    setForm(initial);
    setSubmitted(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
        .form-card { animation: fadeIn 0.5s ease; }
      `}</style>

      <div style={styles.page}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerBadge}>Medical Sciences</div>
          <h1 style={styles.headerTitle}>CTG College of Nursing</h1>
          <p style={styles.headerSub}>Registration cum Admission Form</p>
        </div>

        {/* Form Card */}
        <div style={styles.formCard} className="form-card">
          <form onSubmit={handleSubmit} noValidate>

            {/* Personal Info */}
            <div style={styles.section}>
              <SectionTitle>Personal Information</SectionTitle>
              <div style={styles.grid3}>
                <Field label="First Name" required error={isRequired(form.FirstName) && "First name is required"}>
                  <Input name="FirstName" placeholder="First name" value={form.FirstName} onChange={handleChange} onKeyDown={handleKeyDown} error={isRequired(form.FirstName)} />
                </Field>
                <Field label="Middle Name">
                  <Input name="MiddleName" placeholder="Middle name" value={form.MiddleName} onChange={handleChange} onKeyDown={handleKeyDown} />
                </Field>
                <Field label="Last Name" required error={isRequired(form.LastName) && "Last name is required"}>
                  <Input name="LastName" placeholder="Last name" value={form.LastName} onChange={handleChange} onKeyDown={handleKeyDown} error={isRequired(form.LastName)} />
                </Field>
              </div>

              <div style={{ ...styles.grid2, marginTop: "16px" }}>
                <Field label="Date of Birth (DD/MM/YYYY)" required error={form.dobError || (submitted && !form.DOB && "DOB is required")}>
                  <Input name="DOB" placeholder="DD/MM/YYYY" value={form.DOB} onChange={handleDOBChange} maxLength={10} error={form.dobError || (submitted && !form.DOB)} />
                </Field>
                <Field label="Personal Email">
                  <Input name="PersonalEmail" type="email" placeholder="email@example.com" value={form.PersonalEmail} onChange={handleChange} />
                </Field>
              </div>

              <div style={{ marginTop: "16px" }}>
                <Field label="Gender" required error={submitted && !form.Gender && "Please select gender"}>
                  <RadioGroup
                    name="Gender"
                    value={form.Gender}
                    onChange={(v) => set({ Gender: v })}
                    options={[{ value: "Male", label: "Male" }, { value: "Female", label: "Female" }, { value: "Other", label: "Other" }]}
                  />
                </Field>
              </div>
              {form.CourseId === "11" && (
              <div style={{ marginTop: "16px" }}>
                <Field label="Have you appeared for OJEE?" required error={form.appearedError}>
                  <RadioGroup
                    name="IsAppearedJee"
                    value={form.IsAppearedJee === true ? "yes" : form.IsAppearedJee === false ? "no" : ""}
                    onChange={(v) => set({ IsAppearedJee: v === "yes", appearedError: "" })}
                    options={[{ value: "yes", label: "Yes" }, { value: "no", label: "No" }]}
                  />
                </Field>
              </div>)}
            </div>

            {/* Course & Admission */}
            <div style={styles.section}>
              <SectionTitle>Course & Admission Details</SectionTitle>
              <div style={styles.grid3}>
                <Field label="Select Course" required error={form.courseError}>
                  <Select name="CourseId" value={form.CourseId} 
                  // onChange={(e) => { set({ CourseId: e.target.value, courseError: "" }); }}
                  onChange={(e) => {
                    const val = e.target.value;
                    set({
                      CourseId: val,
                      courseError: "",
                      // Reset OJEE fields if switching away from B.Sc Nursing
                      ...(val !== "11" && { IsAppearedJee: null, appearedError: "" }),
                    });
                  }}
                   error={form.courseError}>
                    <option value="0">Select Course</option>
                    <option value="10">GNM Nursing</option>
                    <option value="11">B.Sc Nursing</option>
                  </Select>
                </Field>
                <Field label="Category" required error={form.categoryError}>
                  <Select name="Category" value={form.Category} onChange={(e) => set({ Category: e.target.value, categoryError: "" })} error={form.categoryError}>
                    <option value="">Select</option>
                    {["ST", "SC", "OBC", "SEBC", "General"].map((c) => <option key={c} value={c}>{c}</option>)}
                  </Select>
                </Field>
                <Field label="Accommodation Type" required error={form.typeError}>
                  <Select name="Type" value={form.Type} onChange={(e) => set({ Type: e.target.value, typeError: "" })} error={form.typeError}>
                    <option value="">Select</option>
                    {["Day Boarding", "Day Scholar", "Residential"].map((t) => <option key={t} value={t}>{t}</option>)}
                  </Select>
                </Field>
              </div>
              <div style={{ ...styles.grid2, marginTop: "16px" }}>
                <Field label="MR Number">
                  <Input name="MR_Number" placeholder="Money receipt number" value={form.MR_Number} onChange={handleChange} />
                </Field>
                <Field label="Amount Paid (₹)">
                  <Input name="Amount" type="tel" maxLength="6" placeholder="0" value={form.Amount} onChange={handleNumberChange} />
                </Field>
              </div>
            </div>

            {/* Contact & Family */}
            <div style={styles.section}>
              <SectionTitle>Contact & Family</SectionTitle>
              <div style={styles.grid2}>
                <Field label="Personal Contact Number" required error={submitted && form.PersonalCellNumber.length !== 10 && "Enter valid 10-digit number"}>
                  <Input name="PersonalCellNumber" type="tel" maxLength="10" placeholder="10-digit number" value={form.PersonalCellNumber} onChange={handleNumberChange} error={submitted && form.PersonalCellNumber.length !== 10} />
                </Field>
                <Field label="Parent's Contact Number" required error={submitted && form.ParentCellNumber.length !== 10 && "Enter valid 10-digit number"}>
                  <Input name="ParentCellNumber" type="tel" maxLength="10" placeholder="10-digit number" value={form.ParentCellNumber} onChange={handleNumberChange} error={submitted && form.ParentCellNumber.length !== 10} />
                </Field>
                <Field label="Father's Name" required error={isRequired(form.FatherName) && "Father's name is required"}>
                  <Input name="FatherName" placeholder="Father's full name" value={form.FatherName} onChange={handleChange} error={isRequired(form.FatherName)} />
                </Field>
                <Field label="Mother's Name" required error={isRequired(form.MotherName) && "Mother's name is required"}>
                  <Input name="MotherName" placeholder="Mother's full name" value={form.MotherName} onChange={handleChange} error={isRequired(form.MotherName)} />
                </Field>
              </div>
            </div>

            {/* Identity */}
            <div style={styles.section}>
              <SectionTitle>Identity & Health</SectionTitle>
              <div style={styles.grid2}>
                <Field label="Aadhaar Number" required error={submitted && form.AdhaarNumber.length !== 12 && "Enter valid 12-digit Aadhaar"}>
                  <Input name="AdhaarNumber" type="tel" maxLength="12" placeholder="12-digit Aadhaar" value={form.AdhaarNumber} onChange={handleNumberChange} error={submitted && form.AdhaarNumber.length !== 12} />
                </Field>
                <Field label="PIN Code" required error={submitted && form.PIN.length !== 6 && "Enter valid 6-digit PIN"}>
                  <Input name="PIN" type="tel" maxLength="6" placeholder="6-digit PIN" value={form.PIN} onChange={handleNumberChange} error={submitted && form.PIN.length !== 6} />
                </Field>
                <Field label="Religion" required error={isRequired(form.Religion) && "Religion is required"}>
                  <Input name="Religion" placeholder="e.g. Hindu, Christian…" value={form.Religion} onChange={handleChange} error={isRequired(form.Religion)} />
                </Field>
                <Field label="Blood Group">
                  <Input name="BloodGroup" placeholder="e.g. A+, O−" value={form.BloodGroup} onChange={handleChange} />
                </Field>
              </div>
            </div>

            {/* Education */}
            <div style={styles.section}>
              <SectionTitle>Educational Background</SectionTitle>
              <div style={styles.grid2}>
                <Field label="Last Qualification" required error={isRequired(form.LastQualifyName) && "Required"}>
                  <Input name="LastQualifyName" placeholder="e.g. 12th / HSC" value={form.LastQualifyName} onChange={handleChange} error={isRequired(form.LastQualifyName)} />
                </Field>
                <Field label="Board Name" required error={isRequired(form.LastQualifyBoardName) && "Required"}>
                  <Input name="LastQualifyBoardName" placeholder="e.g. CBSE, CHSE" value={form.LastQualifyBoardName} onChange={handleChange} error={isRequired(form.LastQualifyBoardName)} />
                </Field>
                <Field label="Roll Number" required error={isRequired(form.LastQualifyRollNumber) && "Required"}>
                  <Input name="LastQualifyRollNumber" placeholder="Board roll number" value={form.LastQualifyRollNumber} onChange={handleChange} error={isRequired(form.LastQualifyRollNumber)} />
                </Field>
                <Field label="Percentage of Marks">
                  <Input name="LastQualifyMarks" type="number" min="0" max="100" placeholder="e.g. 78.5" value={form.LastQualifyMarks}
                    onChange={(e) => {
                      const v = parseFloat(e.target.value);
                      if (!e.target.value || (v >= 0 && v <= 100)) set({ LastQualifyMarks: e.target.value });
                    }} />
                </Field>
              </div>
              <div style={{ marginTop: "16px" }}>
                <Field label="Last College / School Details">
                  <Textarea name="SchoolInfo" placeholder="College/school name with address" value={form.SchoolInfo} onChange={handleChange} rows={3} />
                </Field>
              </div>
            </div>

            {/* Address & Additional */}
            <div style={styles.section}>
              <SectionTitle>Address & Additional Info</SectionTitle>
              <Field label="Full Address" required error={isRequired(form.Address) && "Address is required"}>
                <Textarea name="Address" placeholder="Enter your full residential address" value={form.Address} onChange={handleChange} rows={3} error={isRequired(form.Address)} />
              </Field>
              <div style={{ marginTop: "16px" }}>
                <Field label="Referred By">
                  <Textarea name="ReferredBy" placeholder="Name, address, and contact of referrer" value={form.ReferredBy} onChange={handleChange} rows={2} />
                </Field>
              </div>
            </div>

            {/* Footer Buttons */}
            <div style={styles.footer}>
              <button type="submit" style={styles.btnPrimary} disabled={form.isLoading}>
                {form.isLoading && <span style={styles.spinner} />}
                {form.isLoading ? "Registering…" : "Register Now"}
              </button>
              <button type="button" style={styles.btnSecondary} onClick={handleClear}>
                Clear Form
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Modals */}
      {form.IsSuccess && (
        <SuccessModal
          msgList={form.msgList}
          onClose={() => {
            set({ IsSuccess: false, msgList: [] });
            handleClear();
            window.scrollTo(0, 0);
          }}
        />
      )}
      {form.showError && (
        <ErrorModal
          title={form.errortitle}
          message={form.errMessage}
          errors={form.validationError}
          onClose={() => set({ showError: false, errortitle: "", errMessage: "", validationError: null })}
        />
      )}
    </>
  );
};

export default Nursing;